import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './MainMenu.module.css';

interface MainMenuProps {
  onLogout: () => void;
  hasSubscription: boolean;
  subscriptionVariant?: 'pro' | 'team' | null;
}

const MainMenu: React.FC<MainMenuProps> = ({ onLogout, hasSubscription, subscriptionVariant }) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const canAccessScrims = hasSubscription && subscriptionVariant === 'team';
  const showScrimsTeamTag = !canAccessScrims;

  return (
    <div className={styles.menuContainer} ref={menuRef}>
      <button 
        className={styles.menuButton}
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Main menu"
      >
        <i className="bi bi-list"></i>
      </button>
      
      {isOpen && (
        <div className={styles.menuDropdown}>
          {canAccessScrims && (
            <>
              <Link 
                to="/scrims"
                className={styles.menuItem}
                onClick={() => setIsOpen(false)}
              >
                <i className="bi bi-camera-video me-2"></i>
                Scrims
                {showScrimsTeamTag && (
                  <span className={styles.teamTag}>TEAM</span>
                )}
              </Link>
              <div className={styles.menuDivider} />
            </>
          )}
          <Link 
            to="/account" 
            className={styles.menuItem}
            onClick={() => setIsOpen(false)}
          >
            <i className="bi bi-person me-2"></i>
            Account
          </Link>
          <Link 
            to="/support" 
            className={styles.menuItem}
            onClick={() => setIsOpen(false)}
          >
            <i className="bi bi-chat-quote me-2"></i>
            Support
          </Link>
          <Link 
            to="/about" 
            className={styles.menuItem}
            onClick={() => setIsOpen(false)}
          >
            <i className="bi bi-info-circle me-2"></i>
            About
          </Link>
          <div className={styles.menuDivider} />
          <button 
            className={styles.menuItem}
            onClick={() => {
              setIsOpen(false);
              onLogout();
            }}
          >
            <i className="bi bi-door-closed me-2"></i>
            Logout
          </button>
        </div>
      )}
    </div>
  );
};

export default MainMenu; 